import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'app-document-progress-bar',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule],
  template: `
  <div>
    <div [ngClass]="textClass" [ngStyle]="textStyle">{{text}}</div>
    <mat-progress-bar mode="buffer" [color]="color"></mat-progress-bar>
  </div>
  `
})
export class DocumentProgressBarComponent implements OnInit {

  @Input() color = 'primary';

  @Input() text = 'Daten werden geladen';

  @Input() textClass = '';

  @Input() textStyle: any = {
    'margin-bottom': '1rem',
    'text-align': 'center',
    'font-size': '1.2rem'
  };

  ngOnInit(): void {
  }
}
